import { ChatCategory, type Chat } from '@/contexts/chat/scripts/hooks/useChats/types';
import type { Contact, CreateContactParams } from '@/contexts/contacts/types';
import styles from './index.module.scss';
import BlockIcon from './images/block.svg?react';
import AddIcon from './images/add.svg?react';
import NewContactModal from './components/addModal';

export interface ChatProps {
  chat: Chat;
  contacts: Contact[];
  addContacts: (contacts: CreateContactParams[]) => Promise<void>;
}

const AddFriend = ({ chat, contacts, addContacts }: ChatProps) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const isFriend = useMemo(
    () => contacts.find((contact) => contact.user_id === chat.user.userId),
    [chat.user.userId, contacts]
  );

  const isGroup = useMemo(() => chat.category === ChatCategory.GROUP, [chat.category]);

  const addContactClick = useCallback(async () => {
    setLoading(true);
    const { user } = chat;
    const params: CreateContactParams = {
      chat_id: chat.chat_id,
      id: 0,
      category: 0,
      user_id: user.userId,
      state_msg: '',
      name: user.name || '',
      // TODO: username
      username: user.username || chat.username || '',
      avatar: user.avatar!,
      remark_name: '',
      verified: 0,
      dnd: 0,
      org_id: 0,
      org_name: '',
      external: 0,
      role: 0,
      create_at: user.createdAt!,
      update_at: user.updatedAt!,
    };
    try {
      await addContacts([params]);
      setOpen(false);
    } finally {
      setLoading(true);
    }
  }, [addContacts, chat, setOpen]);

  if (isFriend || isGroup) {
    return null;
  }

  return (
    <>
      <div className={styles.addFriend}>
        <div className={styles.block} onClick={() => message.info('Coming soon.')}>
          <BlockIcon />
          Block
        </div>
        <div
          className={styles.add}
          onClick={() => {
            if (!loading) {
              addContactClick();
            }
          }}
        >
          <AddIcon />
          Add Contacts
        </div>
      </div>
      <NewContactModal chat={chat} open={open} setOpen={setOpen}></NewContactModal>
    </>
  );
};
export default AddFriend;
